import React, { useState, useEffect } from "react";
import { Button, Stack, Typography } from "@mui/material";

import NightReminder from "./svgImage/Evening/Night Reminder.webp";
import NightAppointment from "./svgImage/Evening/Night Appointment.webp";
import Reminder from "./svgImage/Evening/Reminder1.webp";
import Movie from "./svgImage/Evening/Movie.webp";
import Food from "./svgImage/Evening/food1.webp";
import Img4 from "./svgImage/Frame128.png";
import Img5 from "./svgImage/Frame130.png";
import Webview from "./svgImage/Frame235.png";

import HomeAutomation from "./svgImage/Evening/HomeAutomation.webp";

const FrameSection1C = ({ currentIndex, setCurrentIndex }) => {
  const slides = [
    {
      id: 1,
      image: Food,
      title: "PM 1",
      description: "The Ultimate Show-and-Sell Tool",
      paragraph: "CarouselMarketing | BoostSales | MarketingMadeEasy",
    },
    {
      id: 2,
      image: HomeAutomation,
      title: "PM 2",
      description: "Made Easy on WhatsApp",
      paragraph: "BusinessMadeEasy | ShopSmartWithWhatsApp | SeamlessShopping",
    },
    {
      id: 3,
      image: NightAppointment,
      title: "PM 3",
      description: "Confirm with WhatsApp Breeze",
      paragraph: "SecurePayments | FastTransactions | PaymentSimplified",
    },
    {
      id: 4,
      image: Reminder,
      title: "PM 4",
      description: "Through WhatsApp Interactive Flow",
      paragraph:
        "WhatsAppFlow | InteractiveFeedback | CustomerInsightsSimplified",
    },
    {
      id: 5,
      image: Movie,
      title: "PM 5",
      description: "WhatsApp Business Connect",
      paragraph: "WhatsAppCalling | SeamlessSupport | TalkWithWhatsApp",
    },
  ];

  // const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === slides.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <Stack
      sx={{
        position: "relative",
        width: { xl: "100%", lg: "100%", md: "100%", sm: "100%", xs: "100%" },
        height: { xl: "100%", lg: "100%", md: "100%", sm: "100%", xs: "100%" },
        margin: "auto",
        overflow: "hidden",
        borderRadius: "8px",
        // marginTop: { xl: "60px" },
        // border: "1px solid red",
      }}
    >
      {/* Slides */}
      <Stack
        direction="row"
        sx={{
          display: "flex",
          // border: "2px solid green",
          width: "100%",
          height: "100%",
          paddingLeft: { xl: "80px", lg: "80px", md: "32px", sm: "80px" },
          paddingRight: { xl: "80px", lg: "80px", md: "32px", sm: "80px" },
        }}
      >
        <img
          src={slides[currentIndex].image}
          alt={slides[currentIndex].title}
          style={{
            width: "100%",
            height: "100%",
            backgroundSize: "cover", // Ensures the image covers the entire container
            backgroundPosition: "center", // Centers the image in the container
            backgroundRepeat: "no-repeat",
            // backgroundColor: 'rgb(255, 255, 255)',
            borderRadius: '5px',
            // border: "2px solid blacks",
          }}
        />
      </Stack>

      {/* Navigation Buttons */}
      <Button
        onClick={goToPrevious}
        sx={{
          position: "absolute",
          top: { xl: "50%", lg: "50%", md: "45%", sm: "40%", xs: "24%" },
          left: { xl: "16px", lg: "16px", xs: "0px" },
          transform: {
            xl: "translateY(-50%)",
            lg: "translateY(-50%)",
            xs: "translateY(0%)",
          },
          backgroundColor: "white",
          width: "40px",
          height: "40px",
          minWidth: "unset",
          borderRadius: "50%",
          boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
          "&:hover": {
            backgroundColor: "#f0f0f0",
          },
        }}
      >
        ❮
      </Button>
      <Button
        onClick={goToNext}
        sx={{
          position: "absolute",
          top: { xl: "50%", lg: "50%", md: "45%", sm: "40%", xs: "24%" },
          right: { xl: "16px", lg: "16px", xs: "0px" },
          transform: {
            xl: "translateY(-50%)",
            lg: "translateY(-50%)",
            xs: "translateY(0%)",
          },
          backgroundColor: "white",
          width: "40px",
          height: "40px",
          minWidth: "unset",
          borderRadius: "50%",
          boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
          "&:hover": {
            backgroundColor: "#f0f0f0",
          },
        }}
      >
        ❯
      </Button>
    </Stack>
  );
};

export default FrameSection1C;
